// extracted by mini-css-extract-plugin
export default {"placeholder-wrapper":"styles_placeholder-wrapper__p8cw8","placeholder-title":"styles_placeholder-title__AWzt3"};